
export default {
  name: 'ProductDisplayModeToggle',
  model: {
    prop: 'displayMode',
    event: 'update:displayMode',
  },
  props: {
    displayMode: {
      type: String,
      default: 'classic',
    },
    dark: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    groupLabel() {
      return this.$t('components.productList.displayModeLabel')
    },
    modes() {
      return [
        {
          value: 'classic',
          icon: ['fal', 'th-large'],
          label: this.$t('components.productList.displayClassic'),
        },
        {
          value: 'essential',
          icon: ['fal', 'list-ul'],
          label: this.$t('components.productList.displayEssential'),
        },
      ]
    },
  },
  methods: {
    select(value) {
      if (value !== this.displayMode) this.$emit('update:displayMode', value)
    },
  },
}
